module.exports = __webpack_public_path__ + "692f4ed8df63f7eee32ca5a4b1b219e4.png";